import React from "react";
import { LABEL_CLASS } from "components/crm/ui/fieldStyles";

const Label = ({ children, hint, htmlFor }) => (
  <label
    htmlFor={htmlFor}
    className={`flex items-baseline gap-2 ${LABEL_CLASS}`}
  >
    {children}
    {hint && <span className="text-xs font-normal text-faint">{hint}</span>}
  </label>
);

export default Label;
